// Turns spoken punctuation words into symbols, e.g. "patient alert comma oriented period"
const RULES = [
  [/\s*\b(new paragraph)\b\s*/gi, '\n\n'],
  [/\s*\b(new line|next line)\b\s*/gi, '\n'],
  [/\s*\b(question mark)\b/gi, '?'],
  [/\s*\b(exclamation (point|mark))\b/gi, '!'],
  [/\s*\b(semicolon|semi colon)\b/gi, ';'],
  [/\s*\b(colon)\b/gi, ':'],
  [/\s*\b(comma)\b/gi, ','],
  [/\s*\b(full stop)\b/gi, '.'],
];
// "period" as a word ("the certification period of care") stays a word
const NOUN_BEFORE = /\b(the|a|this|that|each|per|cert|certification|episode|waiting|grace|billing|60-day|60 day|sixty day)$/i;
const periodToDot = (t) => t.replace(/(\S*)(\s*)\bperiod\b(\s+of\b)?/gi, (m, before, sp, of, offset, all) => {
  if (of || NOUN_BEFORE.test(all.slice(0, offset + before.length).trim())) return m;
  return `${before}.`;
});

export const applySpokenPunctuation = (text, multiline = true) => {
  let t = ` ${text} `;
  if (!multiline) t = t.replace(/\s*\b(new paragraph|new line|next line)\b\s*/gi, ' ');
  RULES.forEach(([re, sym]) => { t = t.replace(re, sym); });
  t = periodToDot(t);
  return t
    .replace(/[ \t]+/g, ' ')
    .replace(/ *\n */g, '\n')
    .replace(/([.,;:?!])(?=[^\s.,;:?!\n])/g, '$1 ')
    .replace(/(^|[.?!]\s+|\n)([a-z])/g, (m, p, c) => p + c.toUpperCase())
    .trim();
};

// Joins a new dictated chunk onto what is already in the box
export const joinDictation = (prev, chunk, multiline) => {
  let c = multiline ? chunk : chunk.replace(/\n+/g, ' ');
  if (!prev) return c.charAt(0).toUpperCase() + c.slice(1);
  if (/[.?!]\s*$|\n$/.test(prev)) c = c.charAt(0).toUpperCase() + c.slice(1);
  if (/^[.,;:?!\n]/.test(c) || /\n$/.test(prev)) return prev + c;
  return `${prev} ${c}`;
};

const CLEAR = /^(clear|erase|empty) (the |this )?(box|field|all|everything)$/;
const UNDO = /(^|\s)(undo that|scratch that|delete that|undo)$/;

// Voice commands: "clear box" empties the field, "undo that" removes the last dictated phrase
export const voiceCommand = (transcript) => {
  const t = transcript.trim().toLowerCase().replace(/[.!?,]+$/, '');
  if (CLEAR.test(t)) return { type: 'clear' };
  const m = t.match(UNDO);
  if (m) return { type: t === m[2] ? 'undo' : 'discard' };
  return null;
};
